import React, { Component, Fragment, useEffect, useState } from 'react'
import '../../styles/Popup.module.css'
import {
    Form,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
    Modal,
    Space,
    Popconfirm,
    notification,
    message,
    Switch,
    Divider,
} from 'antd';
import {
    PlusOutlined,
    MinusOutlined,
    UnlockOutlined,
    LockOutlined
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';
import { SketchPicker } from 'react-color';

import PopupManager from '../../managers/PopupManager';
import LayoutSlotsSelector from '../views/LayoutSlotsSelector';
import LayoutTemplatesSelector from '../views/LayoutTemplatesSelector';
import { isResSent } from 'next/dist/next-server/lib/utils';
import ColorPicker from '../ColorPicker';
import ButtonGroup from '../views/ButtonGroup';
const { Option } = Select;

const SelectedSlotSlotContext = React.createContext(null);
const ScreenRatioContext = React.createContext(1);

const roundLayoutPiixels = (layout) => {
    layout.width = roundStringNum(layout.width);
    layout.height = roundStringNum(layout.height);
    layout.slots = layout.slots.map(slot => {
        slot.x = roundStringNum(slot.x);
        slot.y = roundStringNum(slot.y);
        slot.width = roundStringNum(slot.width);
        slot.height = roundStringNum(slot.height);
        return slot;
    })
    return layout;
}

const finalizeLayout = (layout) => {
    return roundLayoutPiixels(layout)
}
const roundStringNum = (stringNum) => {
    if (isNaN(parseFloat(stringNum)))
        return ""
    stringNum = `${Math.round(parseFloat(stringNum))}px`;
    return stringNum;
}

function UseForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value => ++value);
}
const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
};

const formTailLayout = {
    wrapperCol: { offset: 5, span: 19 },
};

class Slot extends React.Component {
    constructor(props) {
        super(props);
        this.state = { x: 0, y: 0, width: 0, height: 0 }
        this.isResizeing = false;
    }


    componentDidMount() {

        const { data, onSlotUpdate = () => { }, layout = null } = this.props;
        const widthNum = parseFloat(data.width);
        const heightNum = parseFloat(data.height);
        const xNum = parseFloat(data.x);
        const yNum = parseFloat(data.y);
        const zIndex = data.zindex ? parseInt(data.zindex) : 0;

        this.setState({ x: xNum, y: yNum, width: widthNum, height: heightNum, zIndex: zIndex, layout: layout })
    }

    componentDidUpdate(prevProps) {
        const { layout = null } = this.props;
        if (layout && layout !== prevProps.layout) {
            this.setState({ layout: layout })
        }
    }
    onDrag = (e, d) => {
        if (this.isResizeing)
            return
        const { data, onSlotUpdate = () => { }, lockBound = true } = this.props;
        const widthNum = this.state.width;
        const heightNum = this.state.height;
        var xNum = parseFloat(d.x) / this.context.ratio;
        var yNum = parseFloat(d.y) / this.context.ratio;

        if (this.state.layout && lockBound) {
            if (widthNum + xNum > parseFloat(this.state.layout.width)) {
                if (xNum < 0) {
                    widthNum -= xNum
                    xNum = 0;
                }
                else
                    xNum = parseFloat(this.state.layout.width) - widthNum
            }
            if (heightNum + yNum > parseFloat(this.state.layout.height)) {

                if (yNum < 0) {
                    heightNum -= yNum
                    yNum = 0;
                }
                else
                    yNum = parseFloat(this.state.layout.height) - heightNum
            }
        }

        this.setState({ x: xNum, y: yNum })

        data.width = `${widthNum}px`;
        data.height = `${heightNum}px`;
        data.x = `${xNum}px`;
        data.y = `${yNum}px`;

        onSlotUpdate(data)
        e.preventDefault();
    }

    onResizing = (e, direction, ref, delta, position) => {
        const { lockBound = true } = this.props;
        this.isResizeing = true;
        var widthNum = parseFloat(ref.style.width) / this.context.ratio;
        var heightNum = parseFloat(ref.style.height) / this.context.ratio;
        var xNum = parseFloat(position.x) / this.context.ratio;
        var yNum = parseFloat(position.y) / this.context.ratio;

        const h = heightNum + yNum;

        // console.log("delta " + JSON.stringify(delta))
        // console.log("ref.style.height " + ref.style.height)
        // console.log("heightNum " + heightNum)
        if (this.state.layout && lockBound) {

            if (xNum !== this.state.x) {

                if (xNum < 0) {
                    widthNum -= xNum
                    xNum = 0;
                }
                else if (widthNum + xNum > parseFloat(this.state.layout.width)) {
                    xNum = parseFloat(this.state.layout.width) - widthNum
                }
            }
            if (yNum !== this.state.y) {

                if (yNum < 0) {
                    heightNum -= yNum
                    yNum = 0;
                }
                else if (heightNum + yNum > parseFloat(this.state.layout.height)) {
                    yNum = parseFloat(this.state.layout.height) - heightNum
                }
            }
            if (widthNum !== this.state.width) {

                if (widthNum + xNum > parseFloat(this.state.layout.width)) {
                    widthNum = parseFloat(this.state.layout.width) - xNum
                }
            }
            if (heightNum !== this.state.height) {

                if (heightNum + yNum > parseFloat(this.state.layout.height)) {
                    heightNum = parseFloat(this.state.layout.height) - yNum
                }
            }
        }


        const scaledScreenWidth = Math.floor(parseFloat(this.state.layout.width) * this.context.ratio)
        const scaledScreenHeight = Math.floor(parseFloat(this.state.layout.height) * this.context.ratio)

        const sss = this.context.ratio * (yNum + heightNum)

        if (scaledScreenWidth === this.context.ratio * widthNum) {
            xNum = 0;
            widthNum = parseFloat(this.state.layout.width);
        }
        if (scaledScreenHeight === this.context.ratio * heightNum) {
            yNum = 0;
            heightNum = parseFloat(this.state.layout.height);
        }
        this.setState({ x: xNum, y: yNum, width: widthNum, height: heightNum })
    }
    onResize = (e, direction, ref, delta, position) => {
        const { lockBound = true } = this.props;

        const { data, onSlotUpdate = () => { } } = this.props;
        var widthNum = parseFloat(ref.style.width) / this.context.ratio;
        var heightNum = parseFloat(ref.style.height) / this.context.ratio;
        var xNum = parseFloat(position.x) / this.context.ratio;
        var yNum = parseFloat(position.y) / this.context.ratio;


        const h = heightNum + yNum;

        if (this.state.layout && lockBound) {
            if (xNum !== this.state.x) {

                if (xNum < 0) {
                    widthNum -= xNum
                    xNum = 0;
                }
                else if (widthNum + xNum > parseFloat(this.state.layout.width)) {
                    xNum = parseFloat(this.state.layout.width) - widthNum
                }
            }
            if (yNum !== this.state.y) {

                if (yNum < 0) {
                    heightNum -= yNum
                    yNum = 0;
                }
                else if (heightNum + yNum > parseFloat(this.state.layout.height)) {
                    yNum = parseFloat(this.state.layout.height) - heightNum
                }
            }

            if (widthNum !== this.state.width) {
                if (widthNum + xNum > parseFloat(this.state.layout.width)) {
                    widthNum = parseFloat(this.state.layout.width) - xNum
                }
            }
            if (heightNum !== this.state.height) {
                if (heightNum + yNum > parseFloat(this.state.layout.height)) {
                    heightNum = parseFloat(this.state.layout.height) - yNum
                }
            }
        }

        const scaledScreenWidth = Math.floor(parseFloat(this.state.layout.width) * this.context.ratio)
        const scaledScreenHeight = Math.floor(parseFloat(this.state.layout.height) * this.context.ratio)

        if (scaledScreenWidth === this.context.ratio * widthNum) {
            xNum = 0;
            widthNum = parseFloat(this.state.layout.width);
        }
        if (scaledScreenHeight === this.context.ratio * heightNum) {
            yNum = 0;
            heightNum = parseFloat(this.state.layout.height);
        }

        this.setState({ x: xNum, y: yNum, width: widthNum, height: heightNum })
        data.width = `${widthNum}px`;
        data.height = `${heightNum}px`;
        data.x = `${xNum}px`;
        data.y = `${yNum}px`;
        onSlotUpdate(data)

        e.preventDefault();
        this.isResizeing = false;
    }

    getSlotName = (data) => {
        const { slot_name = "", slot_id = "" } = data;
        const slotName = (slot_name === "") ? slot_id.replace("_", " ") : slot_name;
        return slotName;
    }
    render = () => {
        const { data, active = false, onSelected = () => { }, lockBound = true } = this.props;
        const xNum = parseFloat(this.state.x) * this.context.ratio;
        const yNum = parseFloat(this.state.y) * this.context.ratio;
        const widthNum = parseFloat(this.state.width) * this.context.ratio;
        const heightNum = parseFloat(this.state.height) * this.context.ratio;
        const borderColor = active ? "blue" : "#ccc"

        const z = this.state.zIndex + 100;
        return (
            <Rnd
                key={data.slot_id}

                size={{ width: widthNum, height: heightNum }}
                position={{
                    x: xNum,
                    y: yNum
                }}
                minWidth={1}
                minHeight={1}
                bounds={lockBound ? "parent" : "window"}
                onResize={this.onResizing}
                onResizeStop={this.onResize}
                onDragStop={this.onDrag}
                enableResizing={active}
                disableDragging={!active}
                style={{ boxShadow: `0 0 0 1px ${borderColor} inset`, backgroundColor: "#ddd", cursor: "pointer", boxSizing: "border-box", zIndex: z }}
                onClick={() => onSelected(data)}

            >
                <div className="center-content" style={{ width: "100%", height: "100%", position: "relative" }}>
                    {/* <div style={{ position: "absolute", left: "5px", top: "5px", fontSize: "12px" }}>{`(${this.state.x},${this.state.y})`}</div> */}
                    <Row className="noselect">
                        <Col span={24} className="center-content" style={{ lineHeight: "14px" }}>{this.getSlotName(data)}</Col>
                        <Col span={24} className="center-content" style={{ lineHeight: "14px" }}>{Math.round(this.state.width)}x{Math.round(this.state.height)}</Col>
                    </Row>
                </div>
            </Rnd>
        )
    }
}

Slot.contextTypes = {
    ratio: PropTypes.number // Like prop-types but for context
};

class Screen extends React.Component {

    constructor(props) {
        super(props);
        const { layout, children, boundSize } = this.props
        const { width, height } = layout;
        const widthNum = parseFloat(width);
        const heightNum = parseFloat(height);


        const ratio = Math.min(boundSize / widthNum, boundSize / heightNum)
        this.state = { currentLayout: layout, ratio: ratio, boundSize: boundSize }
    }

    componentDidMount() {
        this.updateFromProps();
    }

    componentDidUpdate(prevProp) {

        if (prevProp.layout === this.props.layout)
            return

        this.updateFromProps();
    }

    updateFromProps = () => {
        const { layout, children, boundSize } = this.props
        const { width, height } = layout;
        const widthNum = parseFloat(width);
        const heightNum = parseFloat(height);


        const ratio = Math.min(boundSize / widthNum, boundSize / heightNum)

        this.setState({ currentLayout: layout, ratio: ratio, boundSize: boundSize })
    }
    getChildContext() {
        // Declare context object
        return { ratio: this.state.ratio };
    }

    render() {
        const { children } = this.props
        const { width, height } = this.state.currentLayout;
        const widthNum = parseFloat(width);
        const heightNum = parseFloat(height);

        const ratio = Math.min(this.state.boundSize / widthNum, this.state.boundSize / heightNum)
        const scaledWidth = ratio * widthNum;
        const scaledHeight = ratio * heightNum;
        return (
            <div style={{ overflow: "hidden", position: "relative", backgroundColor: this.state.currentLayout.background_color, width: scaledWidth, height: scaledHeight }}>
                {children}
                {/* <div onClick={onDeFocus} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "red", zIndex: 0, cursor: "pointer" }}></div> */}
            </div>
        )
    }

}

Screen.childContextTypes = {
    ratio: PropTypes.number // Like prop-types but for context
};
const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #ddd",
    background: "#f0f0f0"
};

const CustomizeLayoutPopup = (props) => {
    const forceUpdate = UseForceUpdate();
    const [currentLayout, setCurrentLayout] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [selectedSlotInfo, setSelectedSlotInfo] = useState(null);
    const [lockBound, setLockBound] = useState(true);
    const [form] = Form.useForm();
    const boundSize = 280;

    useEffect(() => {

        resetToProps();
        // notification["info"]({
        //     message: 'Tutorial',
        //     description:
        //         'Click on any channel slot on the left panel to personalize your layout',
        //     duration: 0
        // })
    }, [])


    const resetToProps = () => {
        const { layout } = props;
        const layoutObj = JSON.parse(layout);
        setSelectedSlot(null)
        setCurrentLayout(layoutObj)
    }

    useEffect(() => {
    }, [currentLayout])

    useEffect(() => {

        if (!selectedSlot)
            return;

        const { x, y, width, height, zindex = 0, slot_id = "", slot_name = "" } = selectedSlot

        form.setFieldsValue({
            channelname: slot_name,
            x: x?.replace("px", ""),
            y: y?.replace("px", ""),
            width: width?.replace("px", ""),
            height: height?.replace("px", ""),
            zindex: zindex,
        });

        const newCurrentLayout = { ...currentLayout }
        newCurrentLayout.slots = newCurrentLayout.slots.map(slot => {
            return slot.slot_id === selectedSlot.slot_id ? selectedSlot : slot
        })

        setCurrentLayout(newCurrentLayout)

    }, [selectedSlot])


    const onTemplateNeedsApply = (template) => {
        this.setState({ currentLayout: JSON.stringify(template) });
    }

    const onFinish = () => {

    }

    const onFinishFailed = () => {

    }

    const onSlotUpdate = (slotData) => {
        const layoutSlots = currentLayout.slots.map(slot => {
            if (slot.slot_id === slotData.slot_id) {
                setSelectedSlot(slotData);
                return slotData
            }
            else
                return slot
        });

        // console.log("layoutSlots " + JSON.stringify(layoutSlots))

        const newLayout = { ...currentLayout }
        newLayout.slots = layoutSlots;
        setCurrentLayout(newLayout);
        // forceUpdate();
    }

    const renderSlots = (onSlotSelected, selectedSlot, lockBound = true) => {

        // console.log("render sllot")
        return currentLayout.slots.map(slot => {


            const active = selectedSlot ? selectedSlot.slot_id === slot.slot_id : false

            if (active) {
                // console.log(JSON.stringify(slot))
                form.setFieldsValue({
                    x: roundStringNum(slot.x)?.replace("px", ""),
                    y: roundStringNum(slot.y)?.replace("px", ""),
                    width: roundStringNum(slot.width)?.replace("px", ""),
                    height: roundStringNum(slot.height)?.replace("px", ""),
                    zindex: (slot ? (slot?.zindex ?? 0) : "")
                });
                return <Slot lockBound={lockBound} onSlotUpdate={onSlotUpdate} onSelected={onSlotSelected} active={active} key={`slot.slot_id${Math.random()}`} data={selectedSlot} layout={currentLayout}></Slot>
            }
            return <Slot onSlotUpdate={onSlotUpdate} onSelected={onSlotSelected} active={active} key={`slot.slot_id${Math.random()}`} data={slot} layout={currentLayout}></Slot>
        })
    }

    const onSlotSelected = (slotData) => {
        setSelectedSlot(slotData)
    }

    const resizeSlotsToNewScreenSize = (newCurrentLayout) => {

        if (parseFloat(newCurrentLayout.width) === 0 || parseFloat(newCurrentLayout.height) === 0)
            return
        var slots = newCurrentLayout.slots;
        slots = slots.map(slot => {
            // console.log("slot.width " + slot.width)
            // console.log("slot.height " + slot.height)
            // console.log("newCurrentLayout.width " + newCurrentLayout.width)
            // console.log("newCurrentLayout.height " + newCurrentLayout.height)
            const slotXRatio = parseFloat(slot.x) / parseFloat(currentLayout.width)
            const slotYRatio = parseFloat(slot.y) / parseFloat(currentLayout.height)
            const slotWidthRatio = parseFloat(slot.width) / parseFloat(currentLayout.width)
            const slotHeightRatio = parseFloat(slot.height) / parseFloat(currentLayout.height)

            const newSlotXNum = slotXRatio * parseFloat(newCurrentLayout.width)
            const newSlotYNum = slotYRatio * parseFloat(newCurrentLayout.height)
            const newSlotWidthNum = slotWidthRatio * parseFloat(newCurrentLayout.width)
            const newSlotHeightNum = slotHeightRatio * parseFloat(newCurrentLayout.height)

            // console.log("slot " + slot.slot_id)
            // console.log("slotWidthRatio " + slotWidthRatio)
            // console.log("slotHeightRatio " + slotHeightRatio)
            // console.log("newSlotWidthNum " + newSlotWidthNum)
            // console.log("newSlotHeightNum " + newSlotHeightNum)
            slot.x = `${newSlotXNum}px`
            slot.y = `${newSlotYNum}px`
            slot.width = `${newSlotWidthNum}px`
            slot.height = `${newSlotHeightNum}px`
            return slot
        })

        newCurrentLayout.slots = slots
        setCurrentLayout(newCurrentLayout);
    }

    const onFormChange = (e) => {
        switch (e.target.name) {
            case "screenwidth_input":
                if (!isNaN(parseFloat(e.target.value))) {
                    const newCurrentLayout = { ...currentLayout }
                    var newScreenWidth = parseFloat(e.target.value);
                    newCurrentLayout.width = `${newScreenWidth}px`
                    resizeSlotsToNewScreenSize(newCurrentLayout)
                }
                else {
                    const newCurrentLayout = { ...currentLayout }
                    newCurrentLayout.width = `0px`
                    resizeSlotsToNewScreenSize(newCurrentLayout)
                }
                break;
            case "screenheight_input":
                if (!isNaN(parseFloat(e.target.value))) {
                    const newCurrentLayout = { ...currentLayout }
                    var newScreenHeight = parseFloat(e.target.value);
                    newCurrentLayout.height = `${newScreenHeight}px`
                    resizeSlotsToNewScreenSize(newCurrentLayout)
                } else {
                    const newCurrentLayout = { ...currentLayout }
                    newCurrentLayout.height = `0px`
                    resizeSlotsToNewScreenSize(newCurrentLayout)
                }
                break;
        }

        if (!selectedSlot)
            return;

        switch (e.target.name) {
            case "channelname_input":

                const newSelectedSlot = { ...selectedSlot }
                newSelectedSlot.slot_name = e.target.value;
                setSelectedSlot(newSelectedSlot);

                break;
            case "x_input":
                if (!isNaN(parseFloat(e.target.value))) {
                    const newSelectedSlot = { ...selectedSlot }
                    var newX = parseFloat(e.target.value);
                    const currentWidthNum = parseFloat(selectedSlot.width)
                    const currentScreenWidthNum = parseFloat(currentLayout.width)

                    if (newX > currentScreenWidthNum || (currentWidthNum + newX) > currentScreenWidthNum) {
                        setSelectedSlot(newSelectedSlot);
                        return;
                    }
                    newSelectedSlot.x = `${newX}px`;
                    setSelectedSlot(newSelectedSlot);
                }
                break;
            case "y_input":
                if (!isNaN(parseFloat(e.target.value))) {
                    const newSelectedSlot = { ...selectedSlot }
                    var newY = parseFloat(e.target.value);
                    const currentHeightNum = parseFloat(selectedSlot.height)
                    const currentScreenHeightNum = parseFloat(currentLayout.height)

                    if (newY > currentScreenHeightNum || (currentHeightNum + newY) > currentScreenHeightNum) {
                        setSelectedSlot(newSelectedSlot);
                        return;
                    }
                    newSelectedSlot.y = `${newY}px`;
                    setSelectedSlot(newSelectedSlot);
                }
                break;
            case "width_input":
                if (!isNaN(parseFloat(e.target.value))) {
                    const newSelectedSlot = { ...selectedSlot }
                    var newWidth = parseFloat(e.target.value);
                    const currentXNum = parseFloat(selectedSlot.x)
                    const currentScreenWidthNum = parseFloat(currentLayout.width)

                    if (newWidth > currentScreenWidthNum || (currentXNum + newWidth) > currentScreenWidthNum) {
                        const w = currentScreenWidthNum - currentXNum;
                        newSelectedSlot.width = `${w}px`;
                        setSelectedSlot(newSelectedSlot);
                        return;
                    }
                    newSelectedSlot.width = `${newWidth}px`;
                    setSelectedSlot(newSelectedSlot);
                }
                break;
            case "height_input":
                if (!isNaN(parseFloat(e.target.value))) {
                    const newSelectedSlot = { ...selectedSlot }
                    var newHeight = parseFloat(e.target.value);
                    const currentYNum = parseFloat(selectedSlot.y)
                    const currentScreenHeightNum = parseFloat(currentLayout.height)

                    if (newHeight > currentScreenHeightNum || (currentYNum + newHeight) > currentScreenHeightNum) {
                        newSelectedSlot.height = `${h}px`;
                        const h = currentScreenHeightNum - currentYNum;
                        setSelectedSlot(newSelectedSlot);
                        return;
                    }
                    newSelectedSlot.height = `${newHeight}px`;
                    setSelectedSlot(newSelectedSlot);
                }
                break;
            case "zindex_input":
                if (!isNaN(parseInt(e.target.value))) {
                    const newSelectedSlot = { ...selectedSlot }
                    newSelectedSlot.zindex = parseInt(e.target.value);
                    setSelectedSlot(newSelectedSlot);
                }
                break;
            default:
                break
        }
    }

    // const save = () => {

    //     const { timelineLayoutData, requestServerPost, usertoken, selectedBrandData, data = null } = this.props;
    //     var params = new FormData();

    //     params.append("timelinelayoutid", timelineLayoutData.TLLID);
    //     params.append("layout", JSON.stringify(currentLayout));
    //     // params.append("startplaytime", timelineLayoutData.startplaytime ? timelineLayoutData.startplaytime : "");
    //     params.append("brandid", selectedBrandData.BrandID);
    //     requestServerPost("update_timelinelayout", params, { }, (response) => {

    //         PopupManager.closePopup();
    //     }, usertoken);
    // }


    const addSlot = () => {
        const newLayout = { ...currentLayout }

        var slotName = "slot_1";

        for (var i = 1; i <= newLayout.slots.length + 1; i++) {
            var name = `slot_${i}`

            const isAvailable = newLayout.slots.every(slot => {
                return slot.slot_id !== name
            });

            if (isAvailable) {
                slotName = name
                break;
            }
        }


        newLayout.slots.push({
            slot_id: slotName,
            x: "0px",
            y: "0px",
            width: "300px",
            height: "300px",
            zindex: "0"
        })

        // newLayout.slots = newLayout.slots.map((slot, index) => {
        //     const indexID = index + 1;
        //     slot.slot_id = `slot_${indexID}`;
        //     return slot
        // })

        setCurrentLayout(newLayout)
        setSelectedSlot(newLayout.slots[newLayout.slots.length - 1])
    }

    const deleteSelectedSlot = () => {
        if (!selectedSlot)
            return;

        if (currentLayout.slots.length <= 1) {
            message.warning("You must have at least one channel slot on your screen")
            return;
        }

        const newLayout = { ...currentLayout }

        newLayout.slots = currentLayout.slots.filter(slot => {
            return slot.slot_id !== selectedSlot.slot_id
        })

        // newLayout.slots = newLayout.slots.map((slot, index) => {
        //     const indexID = index + 1;
        //     slot.slot_id = `slot_${indexID}`;
        //     return slot
        // })

        setCurrentLayout(newLayout)
        setSelectedSlot(null)
    }

    const handleFocus = (e) => {
        e.target.select();
    }

    const onBackgroundColorChanged = (color) => {
        const newLayout = { ...currentLayout };
        newLayout.background_color = color;
        setCurrentLayout(newLayout);
    }

    const onLockBoundChanged = value => {
        setLockBound(value)
    }

    const onToolClicked = (e) => {

        applyTool(e.target.id)
    }


    const applyTool = (toolName) => {

        if (!selectedSlot)
            return;

        var slot = { ...selectedSlot }


        const layoutWidth = parseFloat(currentLayout.width);
        const layoutHeight = parseFloat(currentLayout.height);
        const slotWidth = parseFloat(slot.width);
        const slotHeight = parseFloat(slot.height);
        switch (toolName) {
            case "alignleft":
                slot.x = "0px";
                break
            case "aligncenter":
                const newX = (layoutWidth - slotWidth) / 2;
                slot.x = `${newX}px`;
                break
            case "alignright":
                const newX1 = (layoutWidth - slotWidth);
                slot.x = `${newX1}px`;
                break
            case "aligntop":
                slot.y = "0px";
                break
            case "alignmiddle":
                const newY = (layoutHeight - slotHeight) / 2;
                slot.y = `${newY}px`;
                break
            case "alignbottom":
                const newY1 = (layoutHeight - slotHeight);
                slot.y = `${newY1}px`;
                break

            case "horizontalfill":
                slot.x = "0px";
                slot.width = currentLayout.width;
                break
            case "verticalfill":
                slot.y = "0px";
                slot.height = currentLayout.height;
                break

            case "layerup":
                layerupSlot(slot)
                return
                break
            case "layerdown":
                layerdownSlot(slot)
                break
        }


        const newLayout = { ...currentLayout }

        newLayout.slots = newLayout.slots.map(sl => {
            if (sl.slot_id !== slot.slot_id) {
                return sl
            }
            else {

                setSelectedSlot(slot)
                return slot
            }
        })

        setCurrentLayout(newLayout)
        //     const { timelineLayoutData, requestServerPost, usertoken, selectedBrandData, data = null } = this.props;
        //     var params = new FormData();

        //     params.append("timelinelayoutid", timelineLayoutData.TLLID);
        //     params.append("layout", JSON.stringify(currentLayout));
        //     // params.append("startplaytime", timelineLayoutData.startplaytime ? timelineLayoutData.startplaytime : "");
        //     params.append("brandid", selectedBrandData.BrandID);
        //     requestServerPost("update_timelinelayout", params, { }, (response) => {

        //         PopupManager.closePopup();
        //     }, usertoken);
        // }
    }

    const layerupSlot = (slot) => {
        if (!slot)
            return;

        var slots = currentLayout.slots

        slots = slots.sort((a, b) => {
            return parseInt(a.zindex) - parseInt(b.zindex)
        })

        var selectedSlotIndex = -1
        slots = slots.map((sl, index) => {

            if (sl.slot_id === slot.slot_id) {
                selectedSlotIndex = index;
            }
            sl.zindex = `${index}`

            return sl
        })

        var sslot = slot
        slots = slots.map((sl, index) => {
            if (sl.slot_id === slot.slot_id && parseInt(sl.zindex) < slots.length - 1) {
                const newZ = parseInt(index) + 1
                sl.zindex = `${newZ}`
                sslot = sl
            }
            else if (index === (selectedSlotIndex + 1)) {
                const newZ2 = parseInt(index) - 1
                sl.zindex = `${newZ2}`
            }
            return sl
        })

        const layout = { ...currentLayout }
        layout.slots = slots;
        setCurrentLayout(layout)
        setSelectedSlot(sslot)
    }


    const layerdownSlot = (slot) => {
        if (!slot)
            return;

        var slots = currentLayout.slots

        slots = slots.sort((a, b) => {
            return parseInt(a.zindex) - parseInt(b.zindex)
        })

        var selectedSlotIndex = -1
        slots = slots.map((sl, index) => {

            if (sl.slot_id === slot.slot_id) {
                selectedSlotIndex = index;
            }
            sl.zindex = `${index}`

            return sl
        })

        var sslot = slot
        slots = slots.map((sl, index) => {
            if (sl.slot_id === slot.slot_id && parseInt(sl.zindex) > 0) {
                const newZ = parseInt(index) - 1
                sl.zindex = `${newZ}`
                sslot = sl
            }
            else if (index === (selectedSlotIndex - 1)) {
                const newZ2 = parseInt(index) + 1
                sl.zindex = `${newZ2}`
            }
            return sl
        })

        const layout = { ...currentLayout }
        layout.slots = slots;
        setCurrentLayout(layout)
        setSelectedSlot(sslot)
    }

    const { onApplyLayout = () => { }, onDiscard = () => { } } = props
    const disabledOpacity = 0.5;
    return (
        <SelectedSlotSlotContext.Provider value={selectedSlot}>
            <div key="editlayoutpopup" className="popupcontentcontainer" style={{ height: "100%" }}>
                <Row gutter={[16, 16]} justify="space-around" style={{ width: "auto", height: "100%", padding: "24px", backgroundColor: "#f0f0f0", boxSizing: "border-box" }} >
                    <Col span={24} className="center-content">
                        <Space>
                            SCREEN SIZE
                    <Input.Group compact>
                                <Input
                                    onFocus={handleFocus}
                                    name="screenwidth_input"
                                    style={{ width: 100, textAlign: 'center' }}
                                    placeholder="Width"
                                    onChange={onFormChange}
                                    value={(currentLayout?.width?.replace("px", "")) ?? ""} />
                                <Input
                                    className="site-input-split"
                                    style={{
                                        width: 30,
                                        borderLeft: 0,
                                        borderRight: 0,
                                        pointerEvents: 'none',
                                    }}
                                    placeholder="x"
                                    disabled
                                    bordered={false}
                                />
                                <Input
                                    onFocus={handleFocus}
                                    name="screenheight_input"
                                    className="site-input-right"
                                    style={{
                                        width: 100,
                                        textAlign: 'center',
                                    }}
                                    onChange={onFormChange}
                                    value={(currentLayout?.height?.replace("px", "")) ?? ""}
                                    placeholder="Height"
                                />

                            </Input.Group>
                                    px
                        </Space>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className="center-content">
                        <Space>
                            <Button onClick={addSlot} type="primary" shape="round" size="small" icon={<PlusOutlined />}>Add Channel Slot</Button>
                            {/* <Popconfirm
                                title={selectedSlot ? `Delete ${selectedSlot.slot_id.replace("_", " ")}?` : ""}
                                icon={<ExclamationCircleOutlined />}
                                content='Some descriptions'
                                okText='Confirm'
                                okType='danger'
                                cancelText='Cancel'
                                onOk={() => {
                                    console.log('OK');
                                }}
                                onCancel={() => {
                                    console.log('Cancel');
                                }}
                            > */}
                            <Button onClick={deleteSelectedSlot} type="primary" shape="round" size="small" disabled={!selectedSlot} danger icon={<MinusOutlined />}>Remove Channel Slot</Button>
                            {/* </Popconfirm> */}
                        </Space>
                    </Col>
                    <Col className="center-content" xs={24} sm={24} md={1} lg={1} xl={1} style={{}}>
                        <Row gutter={[16, 16]}>
                            <Col span={24} style={{ padding: "8px" }}>

                                <ButtonGroup disabled={!selectedSlot} items={
                                    [
                                        <Button disabled={!selectedSlot} id="alignleft" onClick={onToolClicked} type="text" title="Align Left" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_alignleft.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="aligncenter" onClick={onToolClicked} type="text" title="Align Center" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_aligncenter.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="alignright" onClick={onToolClicked} type="text" title="Align Right" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_alignright.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="aligntop" onClick={onToolClicked} type="text" title="Align Top" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_aligntop.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="alignmiddle" onClick={onToolClicked} type="text" title="Align Middle" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_alignmiddle.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="alignbottom" onClick={onToolClicked} type="text" title="Align Bottom" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_alignbottom.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,

                                    ]
                                }>
                                    <Button disabled={!selectedSlot} type="text" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_alignleft.svg" style={{ width: "100%", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>

                                </ButtonGroup>
                                <ButtonGroup disabled={!selectedSlot} items={
                                    [
                                        <Button disabled={!selectedSlot} id="verticalfill" onClick={onToolClicked} type="text" title="Vertical Fill" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_verticalfill.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="horizontalfill" onClick={onToolClicked} type="text" title="Horizontal Fill" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_horizontalfill.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                    ]
                                }>
                                    <Button disabled={!selectedSlot} type="text" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_verticalfill.svg" style={{ width: "100%", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>

                                </ButtonGroup>
                                <ButtonGroup disabled={!selectedSlot} items={
                                    [
                                        <Button disabled={!selectedSlot} id="verticaldistribute" onClick={onToolClicked} type="text" title="Distribute Evenly (Vertical)" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_verticaldistribute.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button disabled={!selectedSlot} id="horizontaldistribute" onClick={onToolClicked} type="text" title="Distribute Evenly (horizontal)" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_horizontalldistribute.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                    ]
                                }>
                                    <Button disabled={!selectedSlot} type="text" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_verticaldistribute.svg" style={{ width: "100%", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>

                                </ButtonGroup>


                                <ButtonGroup items={
                                    [
                                        <Button id="layerup" onClick={onToolClicked} type="text" title="Layer Up" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_layerup.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,
                                        <Button id="layerdown" onClick={onToolClicked} type="text" title="Layer Down" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_layerdown.svg" style={{ width: "30px", pointerEvents: "none", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>,

                                    ]
                                }>
                                    <Button disabled={!selectedSlot} type="text" icon={<img src="/cms/assets/svgs/icons/layout_tools/layouttool_layerup.svg" style={{ width: "100%", height: "auto", opacity: selectedSlot ? 1 : disabledOpacity }}></img>}></Button>

                                </ButtonGroup>
                            </Col>
                        </Row>

                    </Col>
                    <Col className="center-content" xs={24} sm={24} md={13} lg={13} xl={13} style={{}}>

                        <Row gutter={[0, 8]} style={{ width: "100%" }} className="center-content">
                            <Col span={24} className="center-content">
                                <div className="center-content" style={{ width: "400px", height: "400px", border: "1px solid #DDDDDD", position: "relative" }} >
                                    {currentLayout ? <Screen layout={currentLayout} boundSize={360} >
                                        {renderSlots(onSlotSelected, selectedSlot, lockBound)}
                                    </Screen> : null}
                                    <div style={{ position: "absolute", left: 0, top: 0, cursor: "pointer", width: "100%", height: "100%" }} onClick={() => { setSelectedSlot(null) }} ></div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="center-content">
                                    <Space>
                                        <span>Restrict to Screen Boundary</span>
                                        <Switch className="lock-switch" danger checkedChildren={<LockOutlined />} unCheckedChildren={<UnlockOutlined />} defaultChecked={lockBound} onChange={onLockBoundChanged} title="Lock to Boundary"></Switch>

                                    </Space>

                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="center-content" xs={24} sm={24} md={10} lg={10} xl={10}>
                        <Row>
                            <Col span={24} className="center-content">
                                <Form

                                    {...formItemLayout}
                                    name="basic"
                                    form={form}
                                    initialValues={{
                                        x: roundStringNum(selectedSlot?.x).replace("px", ""),
                                        y: roundStringNum(selectedSlot?.y).replace("px", ""),
                                        width: roundStringNum(selectedSlot?.width).replace("px", ""),
                                        height: roundStringNum(selectedSlot?.height).replace("px", ""),
                                        zindex: (selectedSlot ? (selectedSlot?.zindex ?? 0) : "")
                                    }}
                                    onChange={onFormChange}
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}
                                >
                                    <Form.Item
                                        {...formTailLayout}
                                    >

                                        {currentLayout ? <Space className="center-content"> <ColorPicker color={currentLayout.background_color} onColorChange={onBackgroundColorChanged}></ColorPicker><span> Background Color</span></Space> : null}


                                    </Form.Item>
                                    <Form.Item
                                        name="channelname"
                                        label="Channel Name"
                                    >
                                        <Input disabled={!selectedSlot} onFocus={handleFocus} autoSave={false} autoComplete={false} name="channelname_input" onChange={onFormChange} />
                                    </Form.Item>
                                    <Form.Item
                                        name="x"
                                        label="x"

                                    >
                                        <Input disabled={!selectedSlot} onFocus={handleFocus} autoSave={false} autoComplete={false} name="x_input" onChange={onFormChange} />
                                    </Form.Item>
                                    <Form.Item
                                        name="y"
                                        label="y"
                                    >
                                        <Input disabled={!selectedSlot} onFocus={handleFocus} autoSave={false} autoComplete={false} name="y_input" onChange={onFormChange} />
                                    </Form.Item>
                                    <Form.Item
                                        name="width"
                                        label="width"
                                    >
                                        <Input disabled={!selectedSlot} onFocus={handleFocus} autoSave={false} autoComplete={false} name="width_input" onChange={onFormChange} />
                                    </Form.Item>
                                    <Form.Item
                                        name="height"
                                        label="height"
                                    >
                                        <Input disabled={!selectedSlot} onFocus={handleFocus} autoSave={false} autoComplete={false} name="height_input" onChange={onFormChange} />
                                    </Form.Item>
                                    <Form.Item
                                        name="zindex"
                                        label="z-index"
                                    >
                                        <Input disabled={!selectedSlot} onFocus={handleFocus} autoSave={false} autoComplete={false} name="zindex_input" onChange={onFormChange} />
                                    </Form.Item>
                                    <Form.Item
                                        {...formTailLayout}
                                        style={{ marginTop: "24px" }}
                                    >
                                        <Space>
                                            <Button style={{ borderRadius: "4px" }} danger htmlType="button" onClick={() => { resetToProps(); onDiscard() }}>Discard</Button>
                                            <Button onClick={() => { setSelectedSlot(null); onApplyLayout(finalizeLayout(currentLayout)) }} type="primary" htmlType="button" >Apply Layout</Button>
                                        </Space>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </div >
        </SelectedSlotSlotContext.Provider >
    );
}


const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(CustomizeLayoutPopup);
